// Only raster formats have server-generated thumbnails and an in-chat viewer.
// SVG is supported as a downloadable document, including in replies and drafts.
export function isAttachmentImage(mime: string): boolean {
  return ['image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(mime);
}
